require('./order-item/order-item.scss');
var BaseViews = require('../base');
var SpinnerButton = require('treeline-shared-components/spinner-button');

var OrderItem = BaseViews.LayoutView.extend({
  className:
      'fmcy-order-item',
  template: require('./order-item/order-item.html'),
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              extraClassName: null
          }
      );
  },
  regions: {
    editBtnRegion: '.fmcy-order-item-btn-edit-region',
    changeBtnRegion: '.fmcy-order-item-btn-change-region',
    cancelBtnRegion: '.fmcy-order-item-btn-cancel-region'
  },
  ui: {
    orderItem: '.fmcy-order-item-code'
  },
  events: {
    'click @ui.orderItem': '_orderItemClicked'
  },
  _renderPayButton: function () {
    var self = this;
    this._payBtn = new SpinnerButton.SpinnerButton({
        label: 'PAY NOW',
        enabled: true,
        theme: SpinnerButton.THEMES.PRIMARY,
        size: SpinnerButton.SIZES.SMALL,
        onClickedCallback: function () {
          self._payBtn.toggleSpinner(true);
          self._payBtn.toggledEnabledState(false);
          self.options._appChannel.trigger('cart:view');
        }
    });

    this.editBtnRegion.show(this._payBtn);
  },
  _renderEditButton: function () {
    var self = this;
    this._editBtn = new SpinnerButton.SpinnerButton({
        label: 'EDIT',
        enabled: true,
        theme: SpinnerButton.THEMES.PRIMARY,
        size: SpinnerButton.SIZES.SMALL,
        onClickedCallback: function () {
          self._renderEditBar();
        }
    });

    this.editBtnRegion.show(this._editBtn);
  },
  _renderEditBar: function () {
    this.$el.addClass('fmcy-editing-order-item');
    //this._renderChangeButton();
    this._renderCancelButton();
  },
  _renderCancelButton: function () {
    self = this;
    this._cancelBtn = new SpinnerButton.SpinnerButton({
        label: 'CANCEL ORDER',
        enabled: true,
        theme: SpinnerButton.THEMES.PRIMARY,
        size: SpinnerButton.SIZES.SMALL,
        onClickedCallback: function () {
          self._cancelBtn.toggleSpinner(true);
          self._cancelBtn.toggledEnabledState(false);
          self.options._appChannel.request('order:cancel', self.model).then(function (response) {
            self.model.set('order_status', 'customer_cancelled');
            self.$el.removeClass('fmcy-editing-order-item');
            self.render();
            Backbone.Radio.channel('global').trigger(
                'order:updated',
                self.model
            );
            self.options._appChannel.trigger('orders:updated');
          }).always(function() {
            self._cancelBtn.toggleSpinner(false);
            self._cancelBtn.toggledEnabledState(true);
          });
        }
    });

    this.cancelBtnRegion.show(this._cancelBtn);
  },
  _renderChangeButton: function () {
    this._changeBtn = new SpinnerButton.SpinnerButton({
        label: 'CHANGE ORDER',
        enabled: true,
        theme: SpinnerButton.THEMES.PRIMARY,
        size: SpinnerButton.SIZES.SMALL,
        onClickedCallback: function () {
          // do something
        }
    });

    this.changeBtnRegion.show(this._changeBtn);
  },
  _isPayable: function () {
    switch (this.model.get('order_status')) {
      case 'pre_payment':
        return true;
      break;
      default:
        return false;
      break;
    }
  },
  _isEditable: function () {
    switch (this.model.get('order_status')) {
      case 'ready':
        if (this.model.get('order_payment_status')) {
          return false;
        } else {
          return true;
        }
      break;
      case 'pre_payment':
      case 'processing':
      case 'created':
        return true;
      break;
      default:
        return false;
      break;
    }
  },
  _isClickable: function () {
    switch (this.model.get('order_status')) {
      case 'pre_payment':
        return false;
      break;
      default:
        return true;
      break;
    }
  },
  _orderItemClicked: function () {
    if (this._isClickable()) {
      this.options._appChannel.trigger('menu:overlay:view:close');
    }
  },
  _gotoOrderDetailsLink: function () {
    var rootUrl = window.location.protocol + '//' + window.location.hostname;
    return rootUrl + '/my-account/#order/' + this.model.get('order_unique_id');
  },
  onRender: function () {
    if (this.options.extraClassName) {
        this.$el.addClass(this.options.extraClassName);
    }
    this.$el.addClass('fmcy-order-status-' + this.model.get('order_status'));

    if (this._isPayable() == true) {
      this._renderPayButton();
    } else {
      if (this._isEditable() == true) {
        this._renderEditButton();
      }
    }
  },
  serializeData: function () {
    var notificationMessage = '';
    switch(this.model.get('order_status')) {
      case 'ready':
        if (this.model.get('order_delivery_method') == 'pickup') {
          notificationMessage = 'Order ' +  this.model.get('order_code') + ' is ready for pickup!';
        } else {
          notificationMessage = 'Order ' +  this.model.get('order_code') + ' is packed up!';
        }
      break;
      case 'cancelled':
      case 'customer_cancelled':
        notificationMessage = 'Order ' +  this.model.get('order_code') + ' cancelled.';
      break;
      case 'completed':
        notificationMessage = 'Order ' +  this.model.get('order_code') + ' completed.';
      break;
      case 'pre_payment':
        notificationMessage = 'Order payment pending.';
      break;
      case 'refunded':
        notificationMessage = 'Order ' +  this.model.get('order_code') + ' refunded.';
      break;
      default:
        notificationMessage = 'Order processing.';
      break;
    }
    return {
      order_details_url: this._gotoOrderDetailsLink(),
      is_clickable: this._isClickable(),
      order_unique_id: this.model.get('order_unique_id'),
      order_code: this.model.get('order_code'),
      order_status: this.model.get('order_status'),
      notification_message: notificationMessage
    };
  }
});

module.exports = OrderItem;



/** WEBPACK FOOTER **
 ** ./assets/js/common/orders/order-item.js
 **/